import React, { useMemo, useCallback } from 'react';
import { FieldProps } from 'formik';
import { UploadImage as UploadUI } from 'components/UploadImage';

interface BannerUploadProps extends FieldProps {
  htmlFor: string;
  descriptionText: string;
}

const BannerUploadField = ({ field, form, htmlFor, descriptionText }: BannerUploadProps) => {
  const { value, name } = field;
  const { setFieldValue } = form;

  const importedFiles = useMemo(() => {
    return typeof value === 'string' && value.length > 0
      ? [
          {
            id: 0,
            url: value,
            description: '',
            name: 'imagem-salva',
          },
        ]
      : [];
  }, [value]);

  const handleChange = useCallback(
    (files: any[]) => {
      if (files && files.length > 0) {
        const file = files[files.length - 1];

        if ('url' in file && typeof file.url === 'string' && !file.url.startsWith('blob:')) {
          setFieldValue(name, file.url);
        } else {
          const fileToSave = file instanceof File ? file : (file as any).file;
          setFieldValue(name, fileToSave || file);
        }
      } else {
        setFieldValue(name, '');
      }
    },
    [name, setFieldValue]
  );

  return (
    <UploadUI
      descriptionText={descriptionText}
      htmlFor={htmlFor}
      multipleFiles={false}
      limitFiles={1}
      importedFiles={importedFiles}
      onChange={handleChange}
      accept="image/*, video/mp4"
    />
  );
};

export default BannerUploadField;
